import axios from 'axios';
import API_CONFIG from '../config/apiConfig';

// Create axios instance with default configuration
const api = axios.create({
  baseURL: API_CONFIG.getBaseURL(),
  timeout: API_CONFIG.TIMEOUT,
  withCredentials: true,
  headers: API_CONFIG.DEFAULT_HEADERS,
  // Add cache busting parameter to each request
  paramsSerializer: {
    serialize: (params) => {
      const serialized = new URLSearchParams(params).toString();
      return serialized + (serialized ? '&' : '') + '_t=' + Date.now();
    }
  }
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // You can add auth tokens here if needed
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle common errors
    if (error.response?.status === 401) {
      // Only redirect to admin login for admin routes
      if (error.config?.url?.includes('/admin') || 
          (error.config?.url?.includes('/enquiries') && error.config?.method?.toLowerCase() !== 'post') ||
          (error.config?.url?.includes('/hiring-requests') && error.config?.method?.toLowerCase() !== 'post')) {
        window.location.href = '/admin/login';
      }
      // For public endpoints (like enquiry submission), just let the error propagate
    }
    return Promise.reject(error);
  }
);

export default api; 